import { UtSessionCommandType } from '@/survey-graphql';

export const ACTIVITY_SIGNAL_INTERVAL_MS = 30_000;
export const AUDIO_CHUNK_DURATION_MS = 5_000;
export const MAX_UPLOAD_RETRIES = 3;
export const VOICE_CONNECTION_ERROR_MESSAGE =
  "We couldn't connect your microphone. Please check your internet connection and try again.";

export const VOICE_COMMAND_TYPE_MAP: Record<string, UtSessionCommandType> = {
  next_question: UtSessionCommandType.NextQuestion,
  submit_answer: UtSessionCommandType.SubmitAnswer,
};
